'use client';
// 레인 A — «광고 효과 보기» 내부 클릭 계측. 기존 수집 경로(trackCTA → /api/events/cta → conversion_events)를 그대로 쓴다.
//   cta_name = 'advertise_click', category = 출발 지면(site_detail · empty_district · empty_home · advertise_page …)
import { trackCTA } from '@/lib/analytics';

export function trackAdvertiseClick(from: string): void {
  try { trackCTA('click', 'advertise_click', { category: from.slice(0, 40) }); } catch { /* 계측 실패가 이동을 막지 않는다 */ }
}

/** 제안 페이지 경로(출처 표시). 로그인 요구는 그 페이지에서 버튼을 누른 사람에게만. */
export const proposalHref = (siteId: string, from: string) => `/advertise/site/${siteId}?from=${encodeURIComponent(from)}`;
